import { render, staticRenderFns } from "./TaskTimeLogger.vue?vue&type=template&id=736f9968&scoped=true&"
import script from "./TaskTimeLogger.vue?vue&type=script&lang=js&"
export * from "./TaskTimeLogger.vue?vue&type=script&lang=js&"
import style0 from "./TaskTimeLogger.vue?vue&type=style&index=0&id=736f9968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736f9968",
  null
  
)

export default component.exports